import { Button } from '@xefi/x-react/button';
import { Modal } from '@xefi/x-react/modal';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Status } from '@/models/status';
import type { SurveyBase, SurveyHome } from '@/models/survey';

type UpdateStatusProps = {
   currentSurvey?: SurveyBase | SurveyHome;
   updatedStatus: Status | null;
   setUpdatedStatus: (status: Status | null) => void;
   confirmationModalContent: {
      title: string;
      subTitle: string;
   } | null;
   updateSurveyStatus: (statusId: string, surveyId?: string) => void;
   isLoading: boolean;
};

export const UpdateStatusModal = ({
   currentSurvey,
   updatedStatus,
   setUpdatedStatus,
   confirmationModalContent,
   updateSurveyStatus,
   isLoading,
}: UpdateStatusProps) => {
   const { t } = useTranslation();

   const [isOpen, setIsOpen] = useState(false);

   const handleCloseModal = () => {
      setIsOpen(false);
      setUpdatedStatus(null);
   };

   useEffect(() => {
      if (confirmationModalContent) {
         setIsOpen(true);
      }
   }, [confirmationModalContent]);

   return confirmationModalContent ? (
      <Modal
         isOpen={isOpen}
         onOpenChange={(newOpen: boolean) => {
            setIsOpen(newOpen);
         }}
         onClose={handleCloseModal}
         title={confirmationModalContent.title}
         footer={
            <div className='flex justify-end gap-2'>
               <Button
                  variant='bordered'
                  radius='md'
                  className='border-primary/50'
                  onClick={handleCloseModal}
               >
                  {t('cancel', { ns: 'common' })}
               </Button>
               <Button
                  radius='md'
                  onClick={() => {
                     updateSurveyStatus(updatedStatus!.id, currentSurvey?.id);
                  }}
                  isLoading={isLoading}
               >
                  {t('validate', { ns: 'common' })}
               </Button>
            </div>
         }
      >
         <p className='text-sm'>{confirmationModalContent.subTitle}</p>
      </Modal>
   ) : null;
};
